import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import {
  FantasyGame,
  FantasyLeaderboard,
  FantasyLeaderboardQuery,
  FantasyLeaderboardService,
  LeaderboardType,
  LeaderboardV2Entry,
  LeaderboardV2Query,
  LeaderboardV2Service,
} from '@fgb/core';
import { ScreenType } from '@fgb/portal-component-library/src/lib/directives';
import * as _moment from 'moment';
import { OwlOptions } from 'ngx-owl-carousel-o';
import { Subscription, combineLatest, firstValueFrom } from 'rxjs';
import { OwlCarouselSettings } from 'src/app/shared/utilities/owl-carousel-settings';

const moment = _moment;

enum GAME_TAB {
  LIVE_UPCOMING = 0,
  RESULTS = 1,
}
@Component({
  selector: 'fgb-fantasy-games-page',
  templateUrl: './fantasy-games-page.component.html',
  styleUrls: ['./fantasy-games-page.component.scss'],
})
export class FantasyGamesPageComponent {
  screenType = ScreenType;
  LeaderboardType: LeaderboardType = LeaderboardType.FantasyPoints;
  currentUser: LeaderboardV2Entry | undefined;

  constructor(
    private leaderboardV2Service: LeaderboardV2Service,
    private leaderboardV2Query: LeaderboardV2Query
  ) {}

  ngOnInit() {
    firstValueFrom(this.leaderboardV2Service.fetchLeaderboardV2(undefined, this.LeaderboardType)).then(() => {
      this.currentUser = this.leaderboardV2Query.getLeaderboardV2().find((entry) => entry.IsCurrentUser);
    });
  }
}

@Component({
  selector: 'fgb-fantasy-games-play-page',
  templateUrl: './fantasy-games-play-page.component.html',
  styleUrl: './fantasy-games-page.component.scss',
})
export class FantasyGamesPlayPageComponent implements OnInit, OnDestroy {
  pendingPeriod: number = 48;
  LeaderboardType: LeaderboardType = LeaderboardType.FantasyPoints;
  showGames: boolean = true;

  yearlyLeaderboards: FantasyLeaderboard[];
  monthlyLeaderboard: any[] = [];

  showMonthly: boolean = true;
  year: number = new Date().getFullYear();

  customOptions: OwlOptions = {
    items: 1,
    margin: OwlCarouselSettings.Margin,
    mouseDrag: false,
    touchDrag: false,
    pullDrag: false,
    navSpeed: 700,
    center: false,
    nav: true,
    dots: false,
    startPosition: new Date().getMonth(),
    navText: ['<i class="material-icons fw-bold">chevron_left</i>', '<i class="material-icons fw-bold">chevron_right</i>'],
    stagePadding: 0,
  };

  fantasySub: Subscription;

  constructor(
    private router: Router,
    private fantasyLeaderboardService: FantasyLeaderboardService,
    private fantasyLeaderboardQuery: FantasyLeaderboardQuery
  ) {}

  ngOnInit() {
    this.fantasySub = combineLatest([
      this.fantasyLeaderboardService.fetchMonthlyLeaderboard(3),
      this.fantasyLeaderboardService.fetchYearlyLeaderboard(3),
    ]).subscribe((x) => {
      let monthly = this.fantasyLeaderboardQuery.getMonthlyLeaderboard() as FantasyLeaderboard[];
      this.yearlyLeaderboards = this.fantasyLeaderboardQuery.getYearlyLeaderboard();

      let today = new Date();

      for (let index = 1; index <= 12; index++) {
        this.monthlyLeaderboard.push({
          month: moment.monthsShort(index - 1) + ' ' + today.getFullYear(),
          entries: monthly.filter((x: FantasyLeaderboard) => {
            return (x.FantasyMonth as unknown as number) === index;
          }),
        });
      }
    });
  }

  ngOnDestroy() {
    if (this.fantasySub) {
      this.fantasySub.unsubscribe();
    }
  }

  goToDetail(gameId: number) {
    this.router.navigate([`games-v2/pickaplayer/${gameId}`]);
  }

  hasActivePlayer(game: FantasyGame) {
    return game.GamePlayers.some((g) => g.IsSelected);
  }

  onTabChage(tab: GAME_TAB): void {
    if (tab === GAME_TAB.LIVE_UPCOMING) {
      this.showGames = true;
    } else if (tab === GAME_TAB.RESULTS) {
      this.showGames = false;
    }
  }
}
